import { Dispatch } from "redux";
import { StudentFollowMapInterface, StudentInterface } from "../db/models/student/student";
import { DocTimestamp } from "../db/models/extra";
import { storeFollows } from "../slices/profile";
import { getRmsById } from "../api/company";

export const studentFollowingRmIdArray = (student: StudentInterface): string[] => {
    const followingRmMap: StudentFollowMapInterface = student?.follows || {};
    return Object.keys(followingRmMap);
}

export const followingRmArrayToStore = (rmIdArray: string[] = [], dispatch: Dispatch) => {
    getRmsById(rmIdArray, (rms) => dispatch(storeFollows(rms)));
}

export const whenStudentFollowedRmTimestamp = (student: StudentInterface, rmId: string): DocTimestamp | null => {
    const followValue = student?.follows?.[rmId];
    const followingTime = followValue?.created || null;
    return followingTime;
};

export const completedRmNotificationSent = (student: StudentInterface, rmId: string): boolean | null => {
    if(!rmId) return null;

    const followMap = student?.follows;
    const follow = followMap?.[rmId] || null;
    if(!follow) return null;

    return follow?.completionEmailSent || false;
};